var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsWebinar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2269_25627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.36328 17.9854C8.36328 14.6716 11.0496 11.9854 14.3633 11.9854H50.2894C53.6031 11.9854 56.2894 14.6716 56.2894 17.9854V43.0146H8.36328V17.9854Z",
    fill: "#8984FF",
    stroke: "#F1F0FF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.3265,
    cy: 19.805,
    r: 3.49448,
    fill: "#FFD8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7227 35.6016L48.2773 35.5979",
    stroke: "#FFD8D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.4314,
    cy: 35.5974,
    r: 3.09156,
    fill: "#FFD8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1998 25.5377L28.9651 25.5374C26.2543 25.5373 23.3931 30.8143 26.1039 30.8143H33.0545H38.5346C39.2403 30.8143 39.724 30.1031 39.4647 29.4468L38.9197 28.0677C38.3164 26.5409 36.8415 25.5377 35.1998 25.5377Z",
    fill: "#FFD8D6",
    stroke: "#FFD8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.31641 45.3831C2.31641 45.1936 2.46999 45.04 2.65945 45.04H61.3437C61.5331 45.04 61.6867 45.1936 61.6867 45.3831C61.6867 49.0459 58.7174 52.0152 55.0546 52.0152H8.94856C5.28572 52.0152 2.31641 49.0459 2.31641 45.3831Z",
    fill: "#6059FF",
    stroke: "#6059FF",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2269_25627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsWebinar);
export default __webpack_public_path__ + "static/media/products-webinar.db2175ff65e6c256aed0662783480c68.svg";
export { ForwardRef as ReactComponent };